import type { SprintType } from '@nedelnik/shared';

import type { Theme } from '../theme.js';

/**
 * Что из настроек пока открыто.
 *
 * Тёмная тема и месячные спринты сделаны, но закрыты до доработки (решение
 * владельца, 2026-09-13). Кнопки остаются на месте и на нажатие объясняют,
 * почему не срабатывают: исчезнувший выбор выглядел бы как поломка, а
 * объяснённый — как план.
 *
 * Закрыто не только на кнопках, но и там, где значение применяется: у кого-то в
 * `localStorage` уже лежит «тёмная», а в настройках на сервере — «месяц», и без
 * этого они так и остались бы в закрытом режиме. Само хранимое значение при
 * этом не трогается — откроем, и вернётся то, что человек выбирал.
 */

export const AVAILABLE_THEMES: readonly Theme[] = ['light'];
export const AVAILABLE_SPRINT_TYPES: readonly SprintType[] = ['week'];

export const THEME_SOON =
  'Пока доступна только светлая тема. Мы работаем над тем, чтобы добавить тёмную и системную.';
export const SPRINT_TYPE_SOON =
  'Пока доступны только недельные спринты. Мы работаем над тем, чтобы добавить месячные.';

export function availableTheme(theme: Theme): Theme {
  return AVAILABLE_THEMES.includes(theme) ? theme : 'light';
}

export function availableSprintType(type: SprintType): SprintType {
  return AVAILABLE_SPRINT_TYPES.includes(type) ? type : 'week';
}
